<template>
    <div>
        <breadcrumbs
            :title="'Porezi'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Porez: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <porez-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                ></porez-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import PorezForma from "./PorezForma";
export default {
    name: "PorezDetails",
    components: {
        PorezForma,
        Breadcrumbs
    },
    data(){
        return {
            id: this.$route.params.porez_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/porezi',
                    name: 'Porezi'
                },
                {
                    path: '/postavke/porezi/create',
                    name: 'Porez: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.postotak || ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
